module.exports = __webpack_public_path__ + "img/icon-safe4.55025766.png";